export const LOCAL_KEY = {
    CURRENT_USER: 'currentUser',
    USER_LANGUAGE: 'userLanguage',
}